export default (browserDetails) => {
  const osDetails = browserDetails.os || {};
  const deviceDetails = browserDetails.device || {};
  const device = `${deviceDetails.vendor || ''}-${deviceDetails.model || ''}-${deviceDetails.type || ''}`;
  const os = `${osDetails.name || ''}-${osDetails.version || ''}`;
  const browser = `${browserDetails.browser.name || ''}-s${browserDetails.browser.version || ''}`;

  return ({ device, os, browser });
};
